import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-textile-model-category3-lang',
  templateUrl: './textile-model-category3-lang.component.html',
  styleUrls: ['./textile-model-category3-lang.component.css']
})
export class TextileModelCategory3LangComponent implements OnInit {
    textileModelCategory3Keyno;

    public inputListLanguages: LanguageItem[] = [];

    public saving = false;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.textileModelCategory3Keyno = this.stateService.getStateParams()['textilemodelcategory3_keyno'];
    }

    private async loadLanguages() {
        if (!!this.textileModelCategory3Keyno) {
            this.inputListLanguages = await this.datatask.Post(2678, { textilemodelcategory3_keyno: this.textileModelCategory3Keyno });
        }
    }

    public async saveChanges() {
        if (!!this.inputListLanguages) {
            try {
                this.saving = true;

                await this.datatask.Post(2679, { records: this.inputListLanguages });

                this.stateService.back();
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadLanguages();
    }

    ngOnInit() {
        this.init();
    }
}

interface LanguageItem {
    textilemodelcategory3_keyno: string;
    textilemodelcategory3lang_name: string;
    language_id: string;
    language_name: string;
    orderby: string;
}
